import { gsap, ScrollTrigger, SplitText } from "@gsap";

const token = (name) => getComputedStyle(document.documentElement).getPropertyValue(`--pk-${name}`).trim().replace(/^["']|["']$/g, "");

function swapTimeline(first, second, settings) {
	return gsap
		.timeline({ defaults: { ease: "none", stagger: settings.stagger } })
		.to(first.words, { yPercent: -settings.distance })
		.to(second.words, { yPercent: 0 });
}

function initStatementSwap() {
	document.querySelectorAll(".statement_image-layout").forEach((layout) => {
		const heading = layout.querySelector("[data-statement-swap]");
		const firstLine = heading?.querySelector(".statement-line--first");
		const secondLine = heading?.querySelector(".statement-line--second");
		if (!heading || !firstLine || !secondLine) return;

		const settings = {
			distance: parseFloat(token("statement-swap-distance")) || 110,
			stagger: parseFloat(token("statement-swap-stagger")) || 0.15,
			scrub: parseFloat(token("statement-swap-scrub")) || true,
			start: token("statement-swap-start") || "top 70%",
			end: token("statement-swap-end") || "top 20%",
		};

		gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
			heading.classList.add("is-swapping");

			const first = new SplitText(firstLine, { type: "lines,words", mask: "lines", wordsClass: "word" });
			const second = new SplitText(secondLine, { type: "lines,words", mask: "lines", wordsClass: "word" });
			gsap.set(second.words, { yPercent: settings.distance });

			ScrollTrigger.create({
				trigger: heading,
				start: settings.start,
				end: settings.end,
				scrub: settings.scrub,
				animation: swapTimeline(first, second, settings),
			});

			return () => {
				first.revert();
				second.revert();
				heading.classList.remove("is-swapping");
			};
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initStatementSwap);
} else {
	initStatementSwap();
}
